import { useMutation as u, useQueryClient as n } from "@tanstack/react-query";
import t from "./support-access.api.js";
const g = (e) => {
  const c = n();
  return u({
    meta: {
      successMessage: "Support access granted",
      errorMessage: "This code is invalid or has expired."
    },
    ...e,
    mutationFn: async (r) => (await t.redeem(r)).data,
    onSuccess: (r, ...a) => {
      var s;
      c.clear(), (s = e == null ? void 0 : e.onSuccess) == null || s.call(e, r, ...a);
    },
    onError: (r, ...a) => {
      var s;
      (s = e == null ? void 0 : e.onError) == null || s.call(e, r, ...a);
    }
  });
}, M = (e) => u({
  mutationFn: async (c) => (await t.generate(c)).data,
  meta: {
    successMessage: "Support access code generated",
    errorMessage: "Failed to generate a support access code."
  },
  ...e
});
export {
  M as useGenerateSupportAccessMutation,
  g as useRedeemSupportAccessMutation
};
